import CurrencyValueUIModel from './currency-value';

class PaymentSummaryUIModel {
  constructor({
    bankName = undefined,
    billingAddress = null,
    cardHolderName = false,
    cardType = undefined,
    installments = null,
    maskedCardCode = undefined,
    maskedCcNumber = undefined,
    monthlyAmount = null,
    paymentAmount = null,
    transactionTime = undefined,
    lastname = undefined,
    voucher = undefined,
    _meta = null,
  } = {}) {
    this.bankName = bankName;
    this.billingAddress = billingAddress;
    this.cardHolderName = cardHolderName;
    this.cardType = cardType;
    this.installments = installments;
    this.maskedCardCode = maskedCardCode;
    this.maskedCcNumber = maskedCcNumber;
    this.monthlyAmount = monthlyAmount;
    this.paymentAmount = paymentAmount && paymentAmount.total ? new CurrencyValueUIModel(paymentAmount) : paymentAmount;
    this.transactionTime = transactionTime;
    this.lastname = lastname;
    this.voucher = voucher;
    this._meta = _meta;
  }

  getStreetAddress() {
    return this.billingAddress ? `${this.billingAddress.addressOne} ${this.billingAddress.addressTwo ? this.billingAddress.addressTwo : ''}` : '';
  }

  getCountryAddress() {
    return this.billingAddress ? `${this.billingAddress.city} ${this.billingAddress.state} ${this.billingAddress.zipCode}` : '';
  }
}

export default PaymentSummaryUIModel;
